export default __webpack_public_path__ + "static/media/Icon simple-youtube.d9709cce.svg";